import PropTypes from "prop-types";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import ProductGridTwo from "./ProductGridTwo";
import ProductGridCategory from "./ProductGridCategory";
import ProductGridListSingle from "../../components/product/ProductGridListSingle";

const TabProductCategorySingle = ({
  block,
  category,
  productTabClass
}) => {
  const [dynamicLink, setDynamicLink] = useState('/shop?category=' + encodeURI(block.category))

  return (
    <div
    // style={{marginTop: '40px', marginBottom: '40px'}}
      className={`product-area ${block.spaceTopClass ? block.spaceTopClass : ""} ${
        block.spaceBottomClass ? block.spaceBottomClass : ""
      }`}
    >
      <div className="container">
            <h1 style={{ textAlign: 'center', marginBottom: '60px' }}>{block.category}</h1>
                <ProductGridCategory
                  category={category}
                  type={block.category}
                  limit={16}
                  spaceBottomClass="mb-25"
                />
        <div className="view-more text-center mt-20 toggle-btn6 col-12">
          <Link
            className="loadMore6"
            to={process.env.PUBLIC_URL + dynamicLink}
          >
            VIEW MORE PRODUCTS
          </Link>
        </div>
      </div>
    </div>
  );
};

TabProductCategorySingle.propTypes = {
  category: PropTypes.string,
  productTabClass: PropTypes.string,
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string
};

export default TabProductCategorySingle;
